import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { VBox } from '../../../components/Box';
import { getPropByName } from '../../../utils/props';
import { selectUser } from '../selectors';
import { WithUser } from './WithUser';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class UserLabelByIdComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  render() {
    return (
      <VBox>
        <WithUser
          user_id={this.props.user_id}
          company_overview={this.props.company_overview}
          inputLabel={this.props.inputLabel}
        >
          {getPropByName(this.props.user, 'name')}&nbsp;{getPropByName(this.props.user, 'surname')}&nbsp;
          {!this.props.company_overview ? '' : <div>{getPropByName(this.props.user, 'email_address')}</div>}
        </WithUser>
        {/* {<p style={{ margin: '0px' }}>{getPropByName(this.props.user, 'email_address')}</p>} */}
      </VBox>
    );
  }
}

UserLabelByIdComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    user: selectUser(ownProps.user_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserLabelById = compose(withConnect, withRouter)(UserLabelByIdComp);
